<div class="competition-round-list">
  <!-- <router-outlet /> -->
  <nz-tree
    [nzData]="matchDays"
    (nzClick)="nzEvent($event)"
    (nzExpandChange)="nzEvent($event)"
  ></nz-tree>
</div>
